import { CheckboxCircle, Chip, ChipVariants, Grid, Typography, useTheme } from '@hermes/web-components'
import getChipColorConfiguration from '../../../../../../utils/getChipColorConfiguration'
import { StatisticTreatment } from '../../../../../../types'

const Treatment = ({ label, count, variant, backgroundColor, href }: StatisticTreatment) => {
  const theme = useTheme()
  const additionalColorStyle = getChipColorConfiguration(variant)
  const keywordProps = href
    ? { component: 'a', href, variant: variant as ChipVariants }
    : { component: 'div', variant: variant as ChipVariants }

  const variantColor = variant + '200'

  const customBackgroundColor = backgroundColor ? { backgroundColor: backgroundColor } : {}

  return (
    <Grid item>
      <Chip
        {...keywordProps}
        label={
          <Grid container alignItems="center" alignContent="center" component="span" gap="3px">
            <Typography
              variant="body2"
              component="span"
              fontWeight={500}
              maxWidth={250}
              textOverflow="ellipsis"
              overflow="hidden"
            >
              {label}
            </Typography>
            {!!count && (
              <Typography variant="body2" component="span" fontWeight={500}>
                ({count})
              </Typography>
            )}
          </Grid>
        }
        icon={
          variant === 'primary' ? (
            <CheckboxCircle
              sx={{ marginLeft: '0 !important', marginRight: '0 !important', width: '20px', height: '20px' }}
            />
          ) : (
            <></>
          )
        }
        sx={{
          fontWeight: '500',
          cursor: 'pointer',
          '&:hover': {
            background: theme.palette.system[variantColor]
          },
          ...(theme?.custom?.common?.treatmentChip ?? {}),
          ...additionalColorStyle,
          color: theme.custom?.SpecialistPage?.common?.background ?? 'primary.dark',
          ...customBackgroundColor
        }}
      />
    </Grid>
  )
}

export default Treatment
